import { Col, Flex, Image, Row, Typography } from "antd";

import "./Header.css";
import headerImage from "../../../assets/images/Phone_Image.svg";

const { Title, Text } = Typography;

export default function Header() {
    return (
        <div className="header-container">
            <Row gutter={0}>
                <Col xs={24} lg={14} xl={15}>
                    <div className="header-left-section">
                        <Title className="header-title-premium" level={1}>
                            COMPRA
                        </Title>
                        <Title className="header-subtitle-premium" level={1}>
                            EN LÍNEA
                        </Title>

                        <div style={{ marginTop: 10, textAlign: "center" }}>
                            <Text className="header-link-label-premium">
                                ¡No esperes más! Haz clic para comprar tus boletos:
                            </Text>
                            {/* <br /><br />
                            <a
                                href="/boletos"
                                className="header-link-button"
                            >
                                www.rifasgranfamiliagdl.com.mx
                            </a> */}
                            <br />
                            <br />
                            <a
                                href="/boletos"
                                className="header-link-button-premium"
                            >
                                www.rifasgranfamiliagdl.com.mx
                            </a>
                        </div>
                    </div>
                </Col>

                <Col xs={24} lg={10} xl={9}>
                    <Flex className="header-right-section">
                        <Image
                            src={headerImage}
                            alt="Compra en Línea"
                            preview={false}
                            style={{ width: '100%', height: 'auto', maxWidth: '320px' }}
                        />
                    </Flex>
                </Col>
            </Row>
        </div>
    );
}